import Http from "./http";

export const getNotificationsListAPI = (data) => {
  return Http.post("admin/notificationList",data);
};
